/* src/app/manual-adjustment/manual-adjustment-presenter/manual-adjustment-presenter.component.scss */
.separator {
  border: 0 !important;
  width: 1em;
  background-color: white !important;
}
.radio-label {
  margin-bottom: 0;
}
body#themeTag :host ::ng-deep .p-checkbox-label {
  margin-top: 0.5rem;
}
body#themeTag :host ::ng-deep .required-invalid.p-multiselect {
  border: 1px solid #dc2626 !important;
  box-shadow: 0 0 0 1px #dc2626 !important;
}
/*# sourceMappingURL=manual-adjustment-presenter.component.css.map */
